module.exports = __webpack_public_path__ + "img/whatsapp.6aa90004.jpg";